import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { DOORS } from '@core/Constants/Filters/DoorsFilter.constants';
import { useAtomValue } from 'jotai';

import { MultiSelect } from 'Components/MultiSelect/MultiSelect';
import { useMultiSelectFilters } from 'Hooks/SearchFilters/UseMultiSelectFilters';
import { getOptionsWithAggs } from 'Utils/SearchFilters/GetOptionsWithAggs';

import { FilterControlBaseProps } from '../../FilterPanel.entity';

import styles from './DoorsFilter.module.css';

type DoorsFilterProps = FilterControlBaseProps;

export const DoorsFilter = ({
  strings,
  locale,
  isPlpFiltersSeoEnabled,
  tenant,
}: DoorsFilterProps) => {
  const { doors } = useAtomValue(aggregationsAtom);
  const { handleSelect, listWithSelected } = useMultiSelectFilters(
    'doors',
    getOptionsWithAggs(DOORS[locale], doors),
    strings,
    locale,
    isPlpFiltersSeoEnabled,
    tenant,
  );

  return (
    <section className={styles.doorsFilter}>
      <MultiSelect
        groupName="doors"
        classes={{ label: styles.listItem }}
        items={listWithSelected}
        onSelect={handleSelect}
        dataTestId="doors-filter-list"
      />
    </section>
  );
};
